import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
const hashCode = str => {
  let hash = 0;
  if (!str) {
    return hash;
  }
  for (const char of str) {
    const code = char.charCodeAt(0);
    hash = (hash << 5) - hash + code;
    hash |= 0;
  }
  return hash < 0 ? hash * -1 : hash;
};
export default (prefix, ...names) => {
  if (!prefix) {
    throw new Error('prefix has to be a defined, non-null value');
  }
  return _reduceInstanceProperty(names).call(names, (map, name) => _objectSpread({}, map, {
    [name]: `${prefix}_${hashCode(name)}`
  }), {});
};